import React, { useState, useEffect } from "react";
import axios from "axios";
import { parseJwt } from "../../utils/helper";
import Loader from "../Loader";
const Review = () => {
  document.title ="Review | ClickStar";

  const [feedbacks, setFeedbacks] = useState([]);
  const [businessId, setBusinessId] = useState(null);

  const token = localStorage.getItem('token');
  const decodedToken = parseJwt(token);
  const userId = decodedToken?.id; 
  const [loading, setLoading] = useState(true);



  useEffect(() => {
    // Fetch business details using userId
    const fetchBusinessId = async () => {
      try {
        
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/business/user/${userId}`);
        setBusinessId(response.data.bid); // Assuming the response contains business_id
      } catch (error) {
        console.error('Error fetching business details:', error);
      }
    };

    if (userId) {
      fetchBusinessId(); // Only fetch business ID if userId is present
    }
  }, [userId]); // Run this effect when userId changes


  useEffect(() => {
    // Fetch feedbacks if businessId is available
    const fetchFeedbacks = async () => {
      if (businessId) {
        try {
          const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/review/${businessId}`);
          setFeedbacks(response.data.reviews); 
        } catch (error) {
          console.error('Error fetching feedbacks:', error);
        }
      }
    };

    fetchFeedbacks(); // Fetch feedbacks if businessId is available
  }, [businessId]); 
  
  
  function convertUTCToIST(utcDate) {
    const date = new Date(utcDate); // Parse the given UTC date
    const options = { 
      timeZone: 'Asia/Kolkata', 
      hour12: false, 
      year: 'numeric', 
      month: '2-digit', 
      day: '2-digit', 
      hour: '2-digit', 
      minute: '2-digit', 
      // second: '2-digit',
      // millisecond: '2-digit'
    };
  
    // Convert UTC to IST
    return date.toLocaleString('en-IN', options);
  } 

  const handleReply = (phone) => {
    const message = "Hello, How can we we help you ?"; // Customize this message as needed
    const whatsappUrl = `https://wa.me/+91${phone}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };

  useEffect(() => {
    setLoading(true);
    if (businessId) {
    fetch(`${process.env.REACT_APP_API_URL}/api/review/${businessId}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Network response was not ok");
        }
      })
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      }); 
      setTimeout(() => setLoading(false), 5000); // Adjust timing as needed
    }
  }, [businessId]);

  return (
    <div className="p-4  min-h-[calc(100vh-64px)] bg-white">
      <h1 className="text-3xl font-bold text-center mb-6">Reviews Dashboard</h1>
      {loading ? (
        <div className="text-center">
          <Loader />
        </div>
      ) : feedbacks.length === 0 ? (
        <p className="text-center text-gray-300">No reviews available.</p>
      ) : (
        <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {[...feedbacks].reverse().map((feedback) => (
            <div
              key={feedback._id}
              className="relative p-4 bg-yellow-50 rounded-lg shadow-lg border-2 border-neutral-100 hover:shadow-xl transform hover:scale-105 transition duration-300"
            >
              <div className="absolute top-2 right-2 text-sm  bg-gray-200 bg-opacity-50 px-2 py-1 rounded">
                {convertUTCToIST(feedback.updated_at)}
              </div>
                <div className="text-lg font-semibold">{feedback.reviewer_name}</div>
              <div className=" items-center ">
                <div className="flex text-sm py-2">
                    {/* <a href={`mailto:${feedback.email}`}><p>{feedback.email}</p></a> */}
                    <p className="">{feedback.reviewer_phone}</p>
                    <p className="text-right text-sm italic w-full">"{feedback.comments}"</p>

                </div>
                <div className="flex items-center space-x-1">
                  
                {[...Array(5)].map((_, index) => (
                  <span
                    key={index}
                    className={`text-xl ${
                      index < feedback.rating
                        ? "text-yellow-400"
                        : "text-gray-500"
                    }`}
                  >
                    <i className="fas fa-star"></i>
                  </span>
                ))}
                </div>
              </div>
              <div className="mt-4 flex justify-around gap-4">
                <button
                  className="px-4 py-2 w-full bg-yellow-500 hover:bg-yellow-600 rounded-lg text-white text-sm font-medium"
                  onClick={() => handleReply(feedback.reviewer_phone)}
                >
                  <i className="fas fa-reply mr-3"></i>
                  Reply
                </button>
                
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
  
};

export default Review;
